
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Surmayi Shyam </h1>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm employee-sports">
    <div class="container">
        <div class="sec-title text-center">
            <h2>Surmayi <span >Shyam</span></h2>
        </div>
        <div class="row mt-5">
            <div class="col-lg-9">
                <div class=" text-justify">
                    <h2 class="head-lea">MS. NIRALI KARTIK 29 JUNE 2019 <span class="small-sm"> 29 JUNE 2019</span></h2>
                    <p>A Hindustani Classical Vocalist from Mumbai, India, Nirali Kartik started to learn music at the
                        young age of nine. A culturally rich environment at home provided the foundation for her art and
                        nourished her creative abilities. After being introduced in Hindustani Music by Shri P. G.
                        Shinde at Saptak School of Music, Nirali started to learn under the guidance of Shri Vikas
                        Parikh.</p>
                    <p>Nirali is currently training under Pandit Sanjeev Abhyankar. A recipient of Shrestha Sadhaka
                        Award, 2004 and Guru Gangadhar Pradhan Award, 2012, Nirali's devotion and dedication to this
                        sacred art has grown to become a central focus of her life. As Nirali sings, she enters the mood
                        of the Raga, drawing the audience along with an adventurous musical journey. The chance to hear
                        this gifted vocalist, with her exceptional and resonating voice,provides a profound and deeply
                        inspiring glimpse of depth of Indian Music.</p>
                    <p>Her forte lies in elaborate Aalapchari, briskness in Taans and clarity of the Swaras.Her vocal
                        renditions are concluded with semi classical compositions, Bhajans and Padas of Haveli Sangeet.
                    </p>
                </div>
            </div>
            <div class="col-md-3">
                <div class="image-effect-3">
                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/niralikartik.webp"
                        alt="GHRSCF">
                </div>
            </div>
        </div>

        <div class="col-lg-12">

            <p>Nirali has been a pioneer in putting forth Hindustani Classical music to a vast online audience by the
                means of videos on Youtube and has a dedicated viewership of music lovers across the globe. Her
                versatility lies in her understanding of the various genres of music and treating them in her own unique
                style. Her style of singing has made her the voice of several award winning films and documentaries.</p>
            <p>Nirali formed the widely acclaimed music group ' Maati Baani' with her husband Kartik Shah and started a
                new thread of music where Indian Classical met various forms of World traditions in a one-of-its-kind
                experiment on Youtube. Together they collaborate with musicians from different countries and create the
                freshest forms of original music</p>
        </div>

        <div class="border-line-sm"></div>
        <div class="row">
            <div class="col-lg-9">
                <h6 class="fw-bold">Surmayi Shyam</h6>
                <p>Artist : Ms. Nirali Kartik</p>
                <p>Tabla : Shri. Sandesh Popatkar</p>
                <p>Date : Sunday, 29<sup>th</sup> June 2019</p>
                <p>Time : 7.00 Pm</p>
                <p>Venue : Chitnavis Centre, Besides Hislop College, Civil Lines, Nagpur.</p>
            </div>
            <div class="col-md-3">
                <div class="image-effect-3">
                    <h6 class="fw-bold"> INVITATION</h6>
                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/niralikartik_invitation.webp"
                        alt="GHRSCF">
                </div>
            </div>
        </div>
        <div class="border-line-sm"></div>

        <div class="row row-cols-1 row-cols-md-3">
            <div class="col">
                <div class="row">
                    <div class="col-md-7">
                        <div class="widget_title inner-title">
                            <h4 class="fw-bold">Media Coverage</h4>
                        </div>
                    </div>
                    <div class="col-md-5 text-end">
                        <a href="media#media_classical" target="_blank" class="btn button--effect-1"><span>
                                View More</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                        </a>
                    </div>
                </div>
                <iframe width="100%" height="230" src="https://urlzs.com/5shhY" frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
            </div>
            <div class="col">
                <div class="row">
                    <div class="col-md-7">
                        <div class="widget_title inner-title">
                            <h4 class="fw-bold">Videos</h4>
                        </div>
                    </div>
                    <div class="col-md-5 text-end">
                        <a href="videogallery" target="_blank" class="btn button--effect-1"><span>
                                View More</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                        </a>
                    </div>

                </div>
                <iframe width="100%" height="230" src="https://www.youtube.com/embed/wNXpeQyScF8" frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
            </div>
            <div class="col">
                <div class="row">
                    <div class="col-md-7">
                        <div class="widget_title inner-title">
                            <h4 class="fw-bold">Photos</h4>
                        </div>
                    </div>
                    <div class="col-md-5 text-end">
                        <a href="photogallery" target="_blank" class="btn button--effect-1"><span>
                                View More</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                        </a>
                    </div>
                </div>
                <div class="lightBox--gallery">
                    <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-3">
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/nk_1.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/nk_1.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/nk_1.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/nk_2.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/nk_2.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/nk_2.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/nk_3.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/nk_3.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/nk_3.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/nk_4.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/nk_4.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/nk_4.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/nk_5.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/nk_5.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/nk_5.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/nk_6.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/nk_6.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/nk_6.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                    </ul>
                </div>

            </div>
        </div>
    </div>
</section>
